import * as React from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", stroke: "currentColor", strokeWidth: 3, viewBox: "0 0 14 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m1 1 12 12m0-12L1 13" }));
export {
  SvgClose as default
};
//# sourceMappingURL=close.js.map
